class StorageHandler {
    prefix = "pt.";

    getSession(key) {
        let content = null;
        try {
            if (window.sessionStorage) {
                let data = window.sessionStorage.getItem(`${this.prefix}${key}`);
                try {
                    content = JSON.parse(data);
                } catch {
                    content = data;
                }
            }
            return content;
        }catch(err){return "";}
    }

    setSession(key, data) {
        let content = null;
        try {
            if (window.sessionStorage) {
                content = JSON.stringify(data);
                window.sessionStorage.setItem(`${this.prefix}${key}`, content);
            }
        }catch(err){}
    }

    get(key) {
        let content = null;
        try {
            if (window.localStorage) {
                let data = window.localStorage.getItem(`${this.prefix}${key}`);
                try {
                    content = JSON.parse(data);
                } catch {
                    content = data;
                }
            }
            return content;
        }catch(err){return "";}
    }

    set(key, data) {
        let content = null;
        try {
            if (window.localStorage) {
                content = JSON.stringify(data);
                window.localStorage.setItem(`${this.prefix}${key}`, content);
            }
        }catch(err){}
    }

}

export const StorageService = new StorageHandler();